import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { HeaderTab, Selector } from '../../components'
import Loading from '../../components/atom/loading/Loading'

// components
import SearchIcon from '../../assets/image/search/ic-search.svg'
import BoxShadow from '../../components/atom/boxShadow/BoxShadow'
import Button from '../../components/atom/button/Button'
import NumBox from '../../components/atom/numBox/NumBox'
import DropDown from '../../components/dropdown/DropDown'

import MoOptionMenu from '../../components/MoOptionMenu/MoOptionMenu'
import OptionMenu from '../../components/optionMenu/OptionMenu'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// utils
import colors from '../../styles/colors'
import { useAxios } from '../../utils/useAxios'

//bootstrap
import { Form } from 'react-bootstrap'

const OptionList = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480)
  const [isInit, setInit] = useState(true)

  // 데이터
  const [optionGoodsList, setOptionGoodsList] = useState([]) // (data) out optionGoodsList(상품)
  // const [optionGoodsList, setProducts] = useState([]) // (data) in itemList

  const [countAll, setCountAll] = useState(0) // 상품 전체 갯수
  const [countNonsale, setCountNonsale] = useState(0) // 비판매(Y)

  const nonsaleObj = {
    A: '전체',
    N: '판매중',
    Y: '숨김',
  }
  const nonsaleOptions = Object.values(nonsaleObj)
  const [nonsaleStatus, setNonsaleStatus] = useState('A') // 판매상태 값
  const [chkNon, setChkNon] = useState(false)
  const [searchKeyword, setSearchKeyword] = useState('')

  // 체크박스 아이템
  const [checkedItems, setCheckedItems] = useState([])

  // request 값 (판매중/숨김)
  const [saleItems, setSaleItems] = useState([])
  const [nonsaleItems, setNonSaleItems] = useState([])

  const {
    fetchData: fetchGetData,
    loading: getLoading,
    data: getData,
    error: getError,
  } = useAxios()

  const {
    fetchData: fetchPostData,
    data: postData,
    error: postError,
  } = useAxios()

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 480)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  // API 호출(옵션조회)
  const getOptions = async (nonsaleStatus) => {
    const params = {
      nonSale: nonsaleStatus,
      searchKeyword: searchKeyword,
    }

    fetchGetData(constants.API.OPTIONS, 'GET', null, params)
  }

  // API : 옵션 판매/비판매 상태 변경
  const postOptions = (updatedSaleItems, updatedNonSaleItems) => {
    const reqData = {
      saleItems: updatedSaleItems,
      nonsaleItems: updatedNonSaleItems,
    }

    fetchPostData(constants.API.OPTIONS, 'POST', reqData)

    setSaleItems([])
    setNonSaleItems([])
  }

  // 상태 조회 버튼(filter: 카테고리, 판매중/숨김)
  const handleSearchClick = () => {
    getOptions(nonsaleStatus)
    setChkNon(true)
    setInit(false)
  }

  useEffect(() => {
    getOptions(nonsaleStatus)
    // console.log('getData', getData)
  }, [])

  useEffect(() => {
    if (
      getData?.responseCode === TYPE.API_RESPONSE.SUCCESS &&
      getData?.responseData &&
      getData?.responseData?.optionGoodsList
    ) {
      const initialOptions = getData.responseData.optionGoodsList
      setOptionGoodsList(initialOptions)

      setCountAll(initialOptions.length)

      // 숨김 처리 갯수
      const countN = initialOptions.reduce((count, item) => {
        if (item.saleYn === 'N') {
          return count + 1
        }
        return count
      }, 0)

      setCountNonsale(countN)
    }
    setInit(false)
  }, [getData])

  // 옵션 상태 변경(판매/비판매) 성공시
  useEffect(() => {
    if (postData?.responseCode === TYPE.API_RESPONSE.SUCCESS) {
      setCheckedItems([])
      getOptions(nonsaleStatus)
    }
  }, [postData])

  // 옵션 상태 변경(판매/비판매) api 호출
  useEffect(() => {
    if (saleItems.length > 0 || nonsaleItems.length > 0) {
      postOptions(saleItems, nonsaleItems)
    }
  }, [saleItems, nonsaleItems])

  return (
    <>
      <ItemListWrap>
        <article className="mb-4">
          <div>
            <HeaderTit>우리 매장은</HeaderTit>
            <HeaderTxt>
              <span className="totalTxt">{countAll}개의</span>
              옵션 품목이 등록되어 있습니다.
            </HeaderTxt>
          </div>
        </article>
        <BoxShadow className="mb-4 d-flex flex-row align-items-center justify-items-center gap-5">
          <div className="col">
            <div className="row">
              <h4 className="mb-3 fs-6 fw-bold">옵션상태</h4>
              <NumBox
                className="col"
                title={'전체'}
                num={countAll}
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'판매중'}
                num={countAll - countNonsale}
                unit={'개'}
              />
              <NumBox
                className="col"
                title={'숨김'}
                num={countNonsale}
                unit={'개'}
              />
            </div>
          </div>
        </BoxShadow>
        <BoxShadow className={'mb-5'}>
          {/* <h4 className="mb-4 fs-6 fw-bold">{promotionStatus}</h4> */}
          <RowBox>
            <DropDown
              defaultOption="판매상태"
              options={nonsaleOptions}
              setOption={(value) => {
                const key = Object.keys(nonsaleObj).find(
                  (k) => nonsaleObj[k] === value,
                )
                setNonsaleStatus(key)
              }}
              value={nonsaleObj[nonsaleStatus]}
            />
            <StyledInput
              type="text"
              placeholder="옵션명 검색"
              onChange={(e) => setSearchKeyword(e.target.value)}
            />
            <SearchIconBtn>
              <button type="button" onClick={handleSearchClick}>
                <img src={SearchIcon} alt="검색버튼" />
              </button>
            </SearchIconBtn>
          </RowBox>
          <SearchBtn>
            <Button onClick={handleSearchClick}>조회</Button>
          </SearchBtn>
        </BoxShadow>
        <ReponsiveWrap>
          {isMobile ? (
            <div className="mobile-content">
              <MoOptionMenu
                dataItem={optionGoodsList}
                chkNon={chkNon}
                checkedItems={checkedItems}
                setCheckedItems={setCheckedItems}
                saleItems={saleItems}
                setSaleItems={setSaleItems}
                nonsaleItems={nonsaleItems}
                setNonSaleItems={setNonSaleItems}
                postOptions={postOptions}
                isInit={isInit}
                getLoading={
                  getData?.responseData?.optionGoodsList ? false : getLoading
                }
              />
            </div>
          ) : (
            <div className="desktop-content ">
              <OptionMenu
                // dataItems={optionGoodsList}
                dataItem={optionGoodsList}
                chkNon={chkNon}
                checkedItems={checkedItems}
                setCheckedItems={setCheckedItems}
                saleItems={saleItems}
                setSaleItems={setSaleItems}
                nonsaleItems={nonsaleItems}
                setNonSaleItems={setNonSaleItems}
                postOptions={postOptions}
                isInit={isInit}
                getLoading={
                  getData?.responseData?.optionGoodsList ? false : getLoading
                }
              />
            </div>
          )}
        </ReponsiveWrap>
      </ItemListWrap>
    </>
  )
}

export default OptionList

const ItemListWrap = styled.section`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`
const HeaderTit = styled.h4`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.BK};
  margin-bottom: 14px;
  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

const HeaderTxt = styled.p`
  font-size: 30px;
  font-weight: 700;
  color: ${colors.BK};
  .totalTxt {
    color: ${colors.mainG};
    margin-right: 10px;
  }
  @media ${(props) => props.theme.mobile} {
    font-size: 20px;
  }
`
const SearchIconBtn = styled.div`
  margin: 0;
  padding: 0;
  @media ${(props) => props.theme.mobile} {
    display: none;
  }
`
// 조회 버튼
const SearchBtn = styled.div`
  display: none;
  margin-top: 16px;
  @media ${(props) => props.theme.mobile} {
    display: block;
  }
`
const RowBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  @media ${(props) => props.theme.mobile} {
    gap: 7px;
    flex-direction: column;
  }
`
const ReponsiveWrap = styled.div`
  .mobile-content {
    @media ${(props) => props.theme.desktop} {
      display: none;
    }
    @media ${(props) => props.theme.mobile} {
      display: block;
    }
  }
  .desktop-content {
    @media ${(props) => props.theme.desktop} {
      display: block;
    }
    @media ${(props) => props.theme.mobile} {
      display: none;
    }
  }
`
const StyledInput = styled(Form.Control)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  width: 100%;
  height: 48px;
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 0, 0);
  border: 1px solid rgb(229, 229, 229);
  /* &::placeholder {
    color: rgb(0, 0, 0);
  } */
  &:focus {
    outline: none;
    box-shadow: none;
    border: 1px solid rgb(229, 229, 229);
  }
  @media ${(props) => props.theme.mobile} {
    height: 36px;
    font-size: 14px;
    margin-top: 3px;
  }
`
